import styled, { css } from 'styled-components';
import { Form } from 'react-bootstrap';
import { theme } from '../../../theme/theme';

const { first } = theme;

// Define element styles for the component
export const StyledControl = styled(Form.Control)`
  border-radius: .5rem;
  border: 1px solid #C4C4C4;
  background: #fff;
  color: #212529;
  outline: none;

  ${({$isNewDesign}) => $isNewDesign && css`
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.38);
    color: #fff;
    font-size: 15px!

    &:hover, &:focus {
      background: rgba(255, 255, 255, 0.28) !important; 
      color: #fff;
    }
    &::placeholder {
      color: rgba(255, 255, 255, 0.8);
    }
    &:disabled::placeholder {
      color: black;
    }
    &:disabled {
      background-color: rgba(30, 20, 50, 0.4);     
    }
    &:disabled:hover {
      background-color: rgba(30, 20, 50, 0.4) !important;     
    }
    &:active {
      background: rgba(255, 255, 255, 0.16) !important;
    }

  `}

  &:focus {
    border-color: ${first};
    box-shadow: none;
  }
`;

export const TextFragments = styled.span`
  color: ${({$isNewDesign}) => $isNewDesign ? '#fff' : '' }
`

export const StyledGroup = styled(Form.Group)`
  background: transparent;
  margin-bottom: 20px;
`;

export const Required = styled.strong`
  color: #ff6b6b !important;
  margin-left: 4px;
  font-weight: bold;
`